<template>
  <div>
    <div class="asc-parameter-alert-item--container">
      <asc-alert-icon :status="status"></asc-alert-icon>
      <span>{{ getAlertText }}</span>
    </div>
  </div>
</template>

<script>
import AscAlertIcon from '@/components/atoms/AscAlertIcon'
import { AscStatusPropsMixin } from '@/components/mixins'

export default {
  name: 'AscParameterAlertItem',

  components: {
    AscAlertIcon,
  },

  mixins: [AscStatusPropsMixin],

  props: {
    simple: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-parameter-alert-item--container {
  display: flex;
  width: 100%;

  .asc-alert-icon--single {
    padding-right: 4px;

    .v-icon {
      margin-bottom: 2px;
    }
  }
}
</style>
